module.exports = __webpack_public_path__ + "media/images/oauth_app-33502cc26b6d5a011edcfc09588f0ab3.png";